import React, { useEffect, useRef, useState } from "react";
import classes from "./Stage.module.css";

import gsap from "gsap";
import Seat from "./Seat/Seat";

const Stage = (props) => {
  const container = useRef(null);
  const [active,setActive] = useState(null);
  useEffect(() => {
    gsap.from(container.current, {
      delay: 0.5,
      duration: 0.5,
      opacity: 0,
      xPercent: 100,
      stagger: 0.1,
    });
  }, []);

  const select = (value) => {
    console.log(value)
    setActive(value)
    props.setSeat(value)
  };

  return (
    <div className={classes.container} ref={container}>
      <h3>
        Choose a Seat
      </h3>
      {props.data.map((value, index) => {
        if (value[0] === "A" || value[0] === "B" || value[0] === "C") {
          return (
            <div className={classes.row} key={index}>
              <div className={classes.letter + " " + classes.golden}>
                {value[0]}
              </div>
              <div className={classes.seats}>
                {value[1].map((seat, index) => {
                  if (seat[1]) {
                    return (
                      <Seat
                        key={index}
                        className={classes.seat + " " + classes.golden}
                        onClick={select}
                        value={{ letter: value[0], number: seat[0] }}
                      >
                        {seat[0]}
                      </Seat>
                    );
                  } else {
                    return (
                      <Seat
                        key={index}
                        className={
                          classes.seat + " " + classes.goldenUnavailable
                        }
                        onClick={select}
                        value={{ letter: value[0], number: seat[0] }}
                      >
                        {seat[0]}
                      </Seat>
                    );
                  }
                })}
              </div>
            </div>
          );
        } else {
          return (
            <div className={classes.row} key={index}>
              <div className={classes.letter + " " + classes.silver}>
                {value[0]}
              </div>
              <div className={classes.seats}>
                {value[1].map((seat, index) => {
                  if (seat[1]) {
                    return (
                      <Seat
                        key={index}
                        className={classes.seat + " " + classes.silver}
                        onClick={select}
                        value={{ letter: value[0], number: seat[0] }}
                      >
                        {seat[0]}
                      </Seat>
                    );
                  } else {
                    return (
                      <Seat
                        key={index}
                        className={
                          classes.seat + " " + classes.silverUnavailable
                        }
                        onClick={select}
                        value={{ letter: value[0], number: seat[0] }}
                      >
                        {seat[0]}
                      </Seat>
                    );
                  }
                })}
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};
export default Stage;
